'use client';
import { Navbar } from 'flowbite-react';
import Image from 'next/image';
import React, { useState } from 'react';
import MWSVG from './common/svg';
import Link from 'next/link';
import MenuLink from './menu-link';
import MenuLeftPanel from './menu-left-panel';
import MenuBottomPanel from './menu-bottom-panel';
import MenuItem from './menu-item';
import ThemeToggle from './ui/theme-toggle';

const Header = ({ fromNotFound }: any) => {
    const [show, setShow] = useState(false);
    const [showServices, setShowServices] = useState(false);
    const [showAiml, setShowAiml] = useState(false);
    const [showTechnology, setShowTechnology] = useState(false);
    const [showWork, setShowWork] = useState(false);
    const [hovered, setHovered] = useState(false);
    const [hoveredAiml, setHoveredAiml] = useState(false);
    const [hoveredTech, setHoveredTech] = useState(false);
    const [hoveredWork, setHoveredWork] = useState(false);

    return (
        <>
            <Link href="/lets-meet-usa " className="sticky top-[0px] z-[1031]">
                <div className="bg-black py-2.5 px-1.5">
                    <p className="mb-0 text-white text-center font-size-res fs-md fw-500">
                        <span className="gradient-text font-bold">6th May 2026 to 27th June 2026</span> Connecting in the USA:
                        Schedule a Meeting to explore new opportunities
                        <Image
                            alt="left-arrow"
                            src="/img/icons/icon-left-arrow.svg"
                            height="24"
                            width="24"
                            loading="eager"
                            className="ml-2.5"
                        />
                    </p>
                </div>
            </Link>
            <header className="sticky top-[45px] z-[1030] h-18 lg:h-20 border-b dark:border-b-0 border-light dark:bg-transparent dark:border-gray-600 flex flex-col justify-center">
                <Navbar className="!px-0 py-0 bg-transparent lg:h-auto dark:bg-transparent">
                    <div
                        id="navbarToggler"
                        className={show ? 'navbar-toggler cross lg:hidden' : 'navbar-toggler lg:hidden'}
                        onClick={() => {
                            setShow(!show);
                            setShowServices(false);
                            setShowTechnology(false);
                        }}
                    >
                        <span className="icon-bar top-bar"></span>
                        <span className="icon-bar middle-bar"></span>
                        <span className="icon-bar bottom-bar"></span>
                    </div>
                    {fromNotFound ? (
                        <>
                            <Image
                                alt="Moweb"
                                src="/img/img-footer-logo@2x.webp"
                                height="40"
                                width="143"
                                loading="lazy"
                                quality={100}
                                className="logo cursor-pointer dark:hidden"
                                onClick={() => (window.location.href = '/')}
                            />
                            <Image
                                alt="Moweb"
                                src="/img/img-header-logo.svg"
                                height="40"
                                width="143"
                                loading="lazy"
                                quality={100}
                                className="logo cursor-pointer hidden dark:block"
                                onClick={() => (window.location.href = '/')}
                            />
                        </>
                    ) : (
                        <Link href="/" className="shine">
                            <Image
                                alt="Moweb"
                                src="/img/img-footer-logo@2x.webp"
                                height="45"
                                width="145"
                                loading="lazy"
                                className="logo dark:hidden logo-responsive"
                                quality={100}
                            />
                            <Image
                                alt="Moweb"
                                src="/img/img-header-logo.svg"
                                height="45"
                                width="145"
                                loading="lazy"
                                className="logo hidden dark:block logo-responsive"
                                quality={100}
                            />
                        </Link>
                    )}
                    <div className="flex lg:order-2 items-center">
                        <div className="lg:hidden">
                            <span
                                className="cursor-pointer link-footer"
                                onClick={() => {
                                    window.open('mailto:sales@moweb.com');
                                }}
                            >
                                <MWSVG id="tabler-icon-mail" />
                            </span>
                        </div>
                        <ThemeToggle />
                        <Link href={'/contact-us'} className="hidden lg:block btn btn-primary">
                            Contact Us
                        </Link>
                        <p className="mb-0 ml-5">
                            <span
                                className="cursor-pointer link-whatsapp"
                                onClick={() => {
                                    window.open('https://api.whatsapp.com/send/?phone=918123456521&text=Hello');
                                }}
                            >
                                <MWSVG id="ic-whatsapp-header" svgClassName="ic ic-49 dark:hidden" />
                                <Image
                                    alt="Moweb"
                                    src="/img/ic-whatsapp.svg"
                                    height={49}
                                    width={49}
                                    className="logo hidden dark:block"
                                    quality={100}
                                />
                            </span>
                        </p>
                    </div>
                    <Navbar.Collapse className={show ? 'navShow' : 'navHide'} id="navbarNav">
                        {/* <li>
                            {' '}
                            <Link
                                onClick={() => {
                                    setShow(!show);
                                    setShowServices(false);
                                    setShowTechnology(false);
                                }}
                                className="flex lg:block font-medium lg:!border-0 leading-30 lg:leading-80 py-2.5 px-5 lg:py-0 lg:px-[14px] text-textcolor hover:text-blue dark:text-light dark:hover:text-white border-b !border-light  dark:border-gray-700"
                                href="/about-us"
                            >
                                About
                            </Link>
                        </li> */}

                        {/* --------------------services megamenu start   --------------------*/}
                        <li
                            className={hovered ? 'has-menu open-megamenu' : 'has-menu'}
                            onMouseEnter={() => setHovered(true)}
                            onMouseLeave={() => setHovered(false)}
                        >
                            <div
                                className={
                                    hovered
                                        ? 'fw-500 hidden justify-between items-center lg:block border-b !border-light lg:border-0 cursor-pointer leading-30 lg:leading-80 py-2.5 px-5 lg:py-0 lg:ps-[14px] lg:pe-[10px] text-blue hover:bg-gray-50 dark:border-gray-700 dark:!text-light dark:hover:bg-gray-700 dark:hover:text-white md:hover:bg-transparent  md:dark:hover:bg-transparent md:dark:hover:text-white'
                                        : 'fw-500 hidden justify-between items-center lg:block border-b !border-light lg:border-0 cursor-pointer leading-30 lg:leading-80 py-2.5 px-5 lg:py-0 lg:ps-[14px] lg:pe-[10px] text-textcolor hover:text-blue hover:bg-gray-50 dark:border-gray-700 dark:!text-light dark:hover:bg-gray-700 dark:hover:text-white md:hover:bg-transparent  md:dark:hover:bg-transparent md:dark:hover:text-white'
                                }
                            >
                                Services
                                <MWSVG id="ic-down" svgClassName="ms-[2px]" />
                            </div>
                            {/* mobile service menu */}
                            <div
                                onClick={() => setShowServices(!showServices)}
                                className="fw-500 flex justify-between items-center lg:hidden border-b lg:border-0 cursor-pointer leading-30 lg:leading-80 py-2.5 px-5 lg:py-0 lg:ps-[14px] lg:pe-[10px] text-textcolor hover:text-blue hover:bg-gray-50 dark:border-[#4c5773] dark:!text-light dark:hover:bg-gray-700 dark:hover:text-white md:hover:bg-transparent  md:dark:hover:bg-transparent md:dark:hover:text-white"
                            >
                                Services
                                <MWSVG id="ic-right" svgClassName="ms-[2px]" />
                            </div>
                            {/* mobile service menu end*/}
                            <ul
                                className={
                                    showServices
                                        ? 'sub-menu service-menu lg:w-[990px] text-secondary bg-white dark:bg-black dark:backdrop-blur-2xl dark:text-light open'
                                        : 'sub-menu service-menu lg:w-[990px] text-secondary bg-white dark:bg-black dark:backdrop-blur-2xl dark:text-light close'
                                }
                                tabIndex={-1}
                            >
                                <li className="lg:hidden back-icon border-b">
                                    <button
                                        type="button"
                                        aria-labelledby="main menu"
                                        className="btn-close text-reset uppercase flex items-center"
                                        onClick={() => setShowServices(!showServices)}
                                    >
                                        <MWSVG id="ic-left" svgClassName="me-2.5" />
                                        Back to Main Menu
                                    </button>
                                </li>
                                <MenuLeftPanel onclick={() => setHovered(false)} />
                                <li onClick={() => setShow(false)}>
                                    <MenuItem isMenuTitle={false}>
                                        <MenuLink
                                            data="AI and ML Development"
                                            svgId="ic-tech-ai-ml-development"
                                            path="/ai-ml-development-services"
                                            onclick={() => setHovered(false)}
                                            className="gradient-text  !font-bold"
                                        />

                                        <MenuLink
                                            data="Enterprise Software Development"
                                            svgId="ic-enterprise-software-development-new"
                                            path="/enterprise-software-development"
                                            onclick={() => setHovered(false)}
                                        />
                                        <MenuLink
                                            data="Mobile App Development"
                                            svgId="ic-mobile-app-development-new"
                                            path="/mobile-app-development"
                                            onclick={() => setHovered(false)}
                                        />
                                        <MenuLink
                                            data="Web Development"
                                            svgId="ic-web-development-new"
                                            path="/web-development"
                                            onclick={() => setHovered(false)}
                                        />
                                        <MenuLink
                                            data="eCommerce Development"
                                            svgId="ic-tech-ecommerce"
                                            path="/ecommerce-development"
                                            onclick={() => setHovered(false)}
                                        />
                                        <MenuLink
                                            data="CMS Development"
                                            svgId="ic-cms-new"
                                            path="/cms-development"
                                            onclick={() => setHovered(false)}
                                        />

                                        <MenuLink
                                            data="Business Analysis"
                                            svgId="ic-tech-business-analysis"
                                            path="/business-analysis-service-baaas"
                                            onclick={() => setHovered(false)}
                                        />
                                    </MenuItem>
                                </li>
                                <li className="mb-res5" onClick={() => setShow(false)}>
                                    <MenuItem>
                                        <MenuLink
                                            data="Data Engineering Services"
                                            svgId="ic-tech-data"
                                            path="/data-engineering-services"
                                            onclick={() => setHovered(false)}
                                        />
                                        <MenuLink
                                            data="UI/UX Design"
                                            svgId="ic-uiux-new"
                                            path="/ui-ux-design"
                                            onclick={() => setHovered(false)}
                                        />
                                        <MenuLink
                                            data="Digital Marketing"
                                            svgId="ic-digitalmarkting-new"
                                            path="/digital-marketing"
                                            onclick={() => setHovered(false)}
                                        />
                                        <MenuLink
                                            data="DevOps"
                                            svgId="ic-tech-devops"
                                            path="/devops-services"
                                            onclick={() => setHovered(false)}
                                        />
                                        <MenuLink
                                            data="Simpro"
                                            svgId="ic-simpro-new"
                                            path="/simpro-development"
                                            onclick={() => setHovered(false)}
                                        />
                                        <MenuLink data="Odoo" svgId="ic-odoo" path="/odoo" onclick={() => setHovered(false)} />
                                        <MenuLink
                                            data="QA Services"
                                            svgId="ic-tech-qa"
                                            path="/software-testing-qa-services"
                                            onclick={() => setHovered(false)}
                                        />
                                    </MenuItem>
                                </li>
                                <MenuBottomPanel className="hidden lg:block" />
                            </ul>
                        </li>
                        {/* --------------------services megamenu end   --------------------*/}

                        {/* --------------------Aiml megamenu start--------------------*/}
                        <li
                            className={hoveredAiml ? 'has-menu open-megamenu' : 'has-menu'}
                            onMouseEnter={() => setHoveredAiml(true)}
                            onMouseLeave={() => setHoveredAiml(false)}
                        >
                            <div
                                className={
                                    hoveredAiml
                                        ? 'fw-500 hidden justify-between items-center lg:block border-b !border-light lg:border-0 cursor-pointer leading-30 lg:leading-80 py-2.5 px-5 lg:py-0 lg:ps-[14px] lg:pe-[10px] text-blue hover:bg-gray-50 dark:border-gray-700 dark:!text-light dark:hover:bg-gray-700 dark:hover:text-white md:hover:bg-transparent  md:dark:hover:bg-transparent md:dark:hover:text-white'
                                        : 'fw-500 hidden justify-between items-center lg:block border-b !border-light lg:border-0 cursor-pointer leading-30 lg:leading-80 py-2.5 px-5 lg:py-0 lg:ps-[14px] lg:pe-[10px] text-textcolor hover:text-blue hover:bg-gray-50 dark:border-gray-700 dark:!text-light dark:hover:bg-gray-700 dark:hover:text-white md:hover:bg-transparent  md:dark:hover:bg-transparent md:dark:hover:text-white'
                                }
                            >
                                AI/ML
                                <MWSVG id="ic-down" svgClassName="ms-[2px]" />
                            </div>
                            {/* mobile service menu */}
                            <div
                                onClick={() => setShowAiml(!showAiml)}
                                className="fw-500 flex justify-between items-center lg:hidden border-b lg:border-0 cursor-pointer leading-30 lg:leading-80 py-2.5 px-5 lg:py-0 lg:ps-[14px] lg:pe-[10px] text-textcolor hover:text-blue hover:bg-gray-50 dark:border-[#4c5773] dark:!text-light dark:hover:bg-gray-700 dark:hover:text-white md:hover:bg-transparent  md:dark:hover:bg-transparent md:dark:hover:text-white"
                            >
                                AI/ML
                                <MWSVG id="ic-right" svgClassName="ms-[2px]" />
                            </div>
                            {/* mobile service menu end*/}
                            <ul
                                className={
                                    showAiml
                                        ? 'sub-menu service-menu aiml-menu lg:w-[990px] text-secondary bg-white dark:bg-black dark:text-light open'
                                        : 'sub-menu service-menu aiml-menu lg:w-[990px] text-secondary bg-white dark:bg-black dark:text-light close'
                                }
                                tabIndex={-1}
                            >
                                <li className="lg:hidden back-icon border-b">
                                    <button
                                        type="button"
                                        aria-labelledby="main menu"
                                        className="btn-close text-reset uppercase flex items-center"
                                        onClick={() => setShowAiml(!showAiml)}
                                    >
                                        <MWSVG id="ic-left" svgClassName="me-2.5" />
                                        Back to Main Menu
                                    </button>
                                </li>
                                <MenuLeftPanel onclick={() => setHoveredAiml(false)} isAimlMenu={true} />
                                <li onClick={() => setShow(false)} className="aiml-menu-head">
                                    <MenuItem isMenuTitle={false}>
                                        <MenuLink
                                            data="AI Strategy & Consulting"
                                            svgId="ic_ai_strategy"
                                            path="/ai-strategy-consulting"
                                            datadescription=" Expert guidance to plan, validate, and scale AI aligned with your business goals."
                                            onclick={() => setHoveredAiml(false)}
                                        />

                                        <MenuLink
                                            data="Data Engineering & Foundations"
                                            svgId="ic_data_engineering"
                                            path="/data-engineering-foundations"
                                            datadescription="Robust data pipelines that prepare clean, reliable data for AI and analytics."
                                            onclick={() => setHoveredAiml(false)}
                                        />

                                        <MenuLink
                                            data="Machine Learning & MLOps"
                                            svgId="ic_machine_learning"
                                            path="/machine-learning-mlops-services"
                                            datadescription="Production ready machine learning models with automated training and deployment."
                                            onclick={() => setHoveredAiml(false)}
                                        />

                                        <MenuLink
                                            data="Generative AI & Large Language Models(LLMs)"
                                            svgId="ic_llm"
                                            datadescription="Production-ready RAG pipelines, conversational AI, and enterprise chatbots with voice assistants."
                                            path="/generative-ai-llm-development"
                                            onclick={() => setHoveredAiml(false)}
                                        />
                                    </MenuItem>
                                </li>
                                <li className="mb-res5 aiml-menu-head" onClick={() => setShow(false)}>
                                    <MenuItem>
                                        <MenuLink
                                            data="Vision AI & Multimodal AI"
                                            svgId="ic_vision_ai"
                                            path="/vision-ai-multimodal-ai"
                                            datadescription="Vision and multimodal models that interpret images, videos, and complex inputs."
                                            onclick={() => setHoveredAiml(false)}
                                        />

                                        <MenuLink
                                            data="AI Security & Governance"
                                            svgId="ic_ai_security"
                                            path="/ai-security-and-governance"
                                            datadescription="Enterprise AI security frameworks with compliance automation, bias detection, and audit trails"
                                            onclick={() => setHoveredAiml(false)}
                                        />

                                        <MenuLink
                                            data="AI Platforms & Integration"
                                            svgId="ic_ai_platforms"
                                            path="/ai-platform-integration"
                                            datadescription="Seamless AI platform integration connecting enterprise systems, APIs, and cloud providers."
                                            onclick={() => setHoveredAiml(false)}
                                        />

                                        <MenuLink
                                            data="AI Agents & Intelligent Automation"
                                            svgId="ic_ai_agents"
                                            path="/ai-agents-and-intelligent-automation"
                                            datadescription="Autonomous AI agents that execute tasks, make decisions, and streamline operations."
                                            onclick={() => setHoveredAiml(false)}
                                        />
                                    </MenuItem>
                                </li>
                                <MenuBottomPanel className="hidden lg:block" />
                            </ul>
                        </li>
                        {/* --------------------Aiml megamenu end--------------------*/}

                        {/* --------------------technology megamenu start--------------------*/}
                        <li
                            className={hoveredTech ? 'has-menu open-megamenu' : 'has-menu'}
                            onMouseEnter={() => setHoveredTech(true)}
                            onMouseLeave={() => setHoveredTech(false)}
                        >
                            <div
                                className={
                                    hoveredTech
                                        ? 'fw-500 hidden justify-between items-center lg:block border-b !border-light lg:border-0 cursor-pointer leading-30 lg:leading-80 py-2.5 px-5 lg:py-0 lg:ps-[14px] lg:pe-[10px] text-blue hover:bg-gray-50 dark:border-gray-700 dark:!text-light dark:hover:bg-gray-700 dark:hover:text-white md:hover:bg-transparent  md:dark:hover:bg-transparent md:dark:hover:text-white'
                                        : 'fw-500 hidden justify-between items-center lg:block border-b !border-light lg:border-0 cursor-pointer leading-30 lg:leading-80 py-2.5 px-5 lg:py-0 lg:ps-[14px] lg:pe-[10px] text-textcolor hover:text-blue hover:bg-gray-50 dark:border-gray-700 dark:!text-light dark:hover:bg-gray-700 dark:hover:text-white md:hover:bg-transparent  md:dark:hover:bg-transparent md:dark:hover:text-white'
                                }
                            >
                                Technologies
                                <MWSVG id="ic-down" svgClassName="ms-[2px]" />
                            </div>
                            {/* mobile Technologies menu */}
                            <div
                                onClick={() => setShowTechnology(!showTechnology)}
                                className="fw-500 flex justify-between items-center lg:hidden border-b lg:border-0 cursor-pointer leading-30 lg:leading-80 py-2.5 px-5 lg:py-0 lg:ps-[14px] lg:pe-[10px] text-textcolor hover:text-blue hover:bg-gray-50 dark:border-[#4c5773] dark:!text-light dark:hover:bg-gray-700 dark:hover:text-white md:hover:bg-transparent  md:dark:hover:bg-transparent md:dark:hover:text-white"
                            >
                                Technologies
                                <MWSVG id="ic-right" svgClassName="ms-[2px]" />
                            </div>
                            {/* mobile Technologies menu end*/}
                            <ul
                                className={
                                    showTechnology
                                        ? 'sub-menu lg:w-[990px] text-secondary bg-white dark:bg-black dark:text-light open'
                                        : 'sub-menu lg:w-[990px] text-secondary bg-white dark:bg-black dark:text-light close'
                                }
                                tabIndex={-1}
                            >
                                <li className="lg:hidden back-icon border-b">
                                    <button
                                        type="button"
                                        className="btn-close text-reset uppercase flex items-center"
                                        aria-labelledby="mainmenu"
                                        onClick={() => setShowTechnology(!showTechnology)}
                                    >
                                        <MWSVG id="ic-left" svgClassName="me-2.5" />
                                        Back to Main Menu
                                    </button>
                                </li>
                                <MenuLeftPanel onclick={() => setHoveredTech(false)} />
                                <li onClick={() => setShow(false)}>
                                    <MenuItem isMenuTitle={true} menuTitle="Web Frontend" isTech={true}>
                                        <MenuLink
                                            data="Angular"
                                            svgId="ic-angularjs-new"
                                            path="/angularjs-development"
                                            onclick={() => setHoveredTech(false)}
                                        />
                                        <MenuLink
                                            data="ReactJS"
                                            svgId="ic-react-new"
                                            path="/reactjs-development"
                                            onclick={() => setHoveredTech(false)}
                                        />
                                        <MenuLink
                                            data="Vue.js"
                                            svgId="ic-tech-vuejs"
                                            path="/vuejs-development"
                                            onclick={() => setHoveredTech(false)}
                                        />
                                    </MenuItem>
                                    <MenuItem isMenuTitle={true} menuTitle="Mobile" isTech={true}>
                                        <MenuLink
                                            data="iOS"
                                            svgId="ic-tech-ios"
                                            path="/ios-app-development"
                                            onclick={() => setHoveredTech(false)}
                                        />
                                        <MenuLink
                                            data="Android"
                                            svgId="ic-tech-android"
                                            path="/android-app-development"
                                            onclick={() => setHoveredTech(false)}
                                        />
                                        <MenuLink
                                            data="Flutter"
                                            svgId="ic-tech-flutter"
                                            path="/flutter-app-development"
                                            onclick={() => setHoveredTech(false)}
                                        />
                                    </MenuItem>
                                </li>
                                <li onClick={() => setShow(false)}>
                                    <MenuItem isMenuTitle={true} menuTitle="Web Framework" isTech={true}>
                                        <MenuLink
                                            data="Laravel"
                                            svgId="ic-tech-laravel"
                                            path="/laravel-development"
                                            onclick={() => setHoveredTech(false)}
                                        />
                                        <MenuLink
                                            data="Node.js"
                                            svgId="ic-tech-nodejs"
                                            path="/nodejs-development"
                                            onclick={() => setHoveredTech(false)}
                                        />
                                        <MenuLink
                                            data="Django"
                                            svgId="ic-django-new"
                                            path="/django-development"
                                            onclick={() => setHoveredTech(false)}
                                        />
                                        <MenuLink
                                            data="Python"
                                            svgId="ic-python"
                                            path="/python-development"
                                            onclick={() => setHoveredTech(false)}
                                        />
                                    </MenuItem>
                                    <MenuItem isMenuTitle={true} menuTitle="Web Tech Stack" isTech={true}>
                                        <MenuLink
                                            data="Full Stack"
                                            svgId="ic-tech-fullstack"
                                            path="/full-stack-development"
                                            onclick={() => setHoveredTech(false)}
                                        />
                                        <MenuLink
                                            data="MEAN"
                                            svgId="ic-tech-mean"
                                            path="/mean-stack-development"
                                            onclick={() => setHoveredTech(false)}
                                        />
                                        <MenuLink
                                            data="MERN"
                                            svgId="ic-tech-mern"
                                            path="/mern-stack-development"
                                            onclick={() => setHoveredTech(false)}
                                        />
                                    </MenuItem>
                                </li>
                                <li className="mb-res5" onClick={() => setShow(false)}>
                                    <MenuItem isMenuTitle={true} menuTitle="eCommerce" isTech={true}>
                                        <MenuLink
                                            data="Shopify"
                                            svgId="ic-shopify-new"
                                            path="/shopify-development"
                                            onclick={() => setHoveredTech(false)}
                                        />
                                        <MenuLink
                                            data="Magento"
                                            svgId="ic-tech-magento"
                                            path="/magento-development"
                                            onclick={() => setHoveredTech(false)}
                                        />
                                        <MenuLink
                                            data="WooCommerce"
                                            svgId="ic-woocommerce-new"
                                            path="/woocommerce-development"
                                            onclick={() => setHoveredTech(false)}
                                        />
                                        <MenuLink
                                            data="OpenCart"
                                            svgId="ic-opencart-new"
                                            path="/opencart-development"
                                            onclick={() => setHoveredTech(false)}
                                        />
                                    </MenuItem>
                                    <MenuItem isMenuTitle={true} menuTitle="CMS" isTech={true}>
                                        <MenuLink
                                            data="Wordpress"
                                            svgId="ic-tech-wordpress"
                                            path="/wordpress-development"
                                            onclick={() => setHoveredTech(false)}
                                        />
                                    </MenuItem>
                                </li>
                                <MenuBottomPanel className="hidden lg:block" />
                            </ul>
                        </li>
                        {/* --------------------technology megamenu end--------------------*/}
                        {/* <li>
                            <Link
                                onClick={() => setShow(false)}
                                href="/work"
                                className="flex lg:block font-medium lg:!border-0 leading-30 lg:leading-80 py-2.5 px-5 lg:py-0 lg:px-[14px] text-textcolor hover:text-blue dark:!text-light dark:hover:text-white border-b dark:border-[#4c5773]"
                            >
                                Work
                            </Link>
                        </li> */}
                        {/* new work start */}

                        {/* --------------------work megamenu start   --------------------*/}
                        <li
                            className={hoveredWork ? 'has-menu open-megamenu' : 'has-menu'}
                            onMouseEnter={() => setHoveredWork(true)}
                            onMouseLeave={() => setHoveredWork(false)}
                        >
                            <div
                                className={
                                    hoveredWork
                                        ? 'fw-500 hidden justify-between items-center lg:block border-b !border-light lg:border-0 cursor-pointer leading-30 lg:leading-80 py-2.5 px-5 lg:py-0 lg:ps-[14px] lg:pe-[10px] text-blue hover:bg-gray-50 dark:border-gray-700 dark:!text-light dark:hover:bg-gray-700 dark:hover:text-white md:hover:bg-transparent  md:dark:hover:bg-transparent md:dark:hover:text-blue'
                                        : 'fw-500 hidden justify-between items-center lg:block border-b !border-light lg:border-0 cursor-pointer leading-30 lg:leading-80 py-2.5 px-5 lg:py-0 lg:ps-[14px] lg:pe-[10px] text-textcolor hover:text-blue hover:bg-gray-50 dark:border-gray-700 dark:!text-light dark:hover:bg-gray-700 dark:hover:text-white md:hover:bg-transparent  md:dark:hover:bg-transparent md:dark:hover:text-blue'
                                }
                            >
                                Work
                                <MWSVG id="ic-down" svgClassName="ms-[2px]" />
                            </div>
                            {/* mobile service menu */}
                            <div
                                onClick={() => setShowWork(!showWork)}
                                className="fw-500 flex justify-between items-center lg:hidden border-b lg:border-0 cursor-pointer leading-30 lg:leading-80 py-2.5 px-5 lg:py-0 lg:ps-[14px] lg:pe-[10px] text-textcolor hover:text-blue hover:bg-gray-50 dark:border-[#4c5773] dark:!text-light dark:hover:bg-gray-700 dark:hover:text-white md:hover:bg-transparent  md:dark:hover:bg-transparent md:dark:hover:text-blue"
                            >
                                Work
                                <MWSVG id="ic-right" svgClassName="ms-[2px]" />
                            </div>
                            {/* mobile service menu end*/}
                            <ul
                                className={
                                    showWork
                                        ? 'sub-menu service-menu work-menu lg:w-[630px] text-secondary bg-white dark:bg-black dark:backdrop-blur-2xl dark:text-light open'
                                        : 'sub-menu service-menu work-menu lg:w-[630px] text-secondary bg-white dark:bg-black dark:backdrop-blur-2xl dark:text-light close !p-30'
                                }
                                tabIndex={-1}
                            >
                                <li className="lg:hidden back-icon border-b">
                                    <button
                                        type="button"
                                        aria-labelledby="main menu"
                                        className="btn-close text-reset uppercase flex items-center"
                                        onClick={() => setShowWork(!showWork)}
                                    >
                                        <MWSVG id="ic-left" svgClassName="me-2.5" />
                                        Back to Main Menu
                                    </button>
                                </li>

                                <li onClick={() => setShow(false)} className="my-3 px-5 lg:pl-0 lg:!pr-[30px] lg:my-0">
                                    <Link href="/work" className="group">
                                        <Image
                                            src="/img/work/img-our-work.webp"
                                            alt="work"
                                            title="work"
                                            width={270}
                                            height={150}
                                            className="img-fluid mb-2.5 rounded-10"
                                        />
                                        <p className="mb-[2px] font-bold fs-md text-textcolor dark:text-white group-hover:text-[#05A6F0] transition-colors duration-300">
                                            Our Work
                                        </p>
                                        <p className="mb-0 fs-md">
                                            A Portfolio reflects thoughtful solutions designed to solve real problems for growing
                                            businesses.
                                        </p>
                                    </Link>
                                </li>
                                <li className="my-3 px-5 lg:!px-0 lg:my-0" onClick={() => setShow(false)}>
                                    <Link href="/case-studies" className="group">
                                        <Image
                                            src="/img/work/img-case-studies.webp"
                                            alt="Case Studies"
                                            title="Case Studies"
                                            width={270}
                                            height={150}
                                            className="img-fluid mb-2.5 rounded-10"
                                        />
                                        <p className="mb-[2px] font-bold fs-md text-textcolor dark:text-white group-hover:text-[#05A6F0] transition-colors duration-300">
                                            Case Studies
                                        </p>
                                        <p className="mb-0 fs-md">
                                            Projects that highlight our approach to solving real problems and creating practical
                                            business value.
                                        </p>
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        {/* --------------------work megamenu end   --------------------*/}

                        {/* new work end */}
                        <li>
                            <Link
                                onClick={() => setShow(false)}
                                href="/blog"
                                className="flex lg:block font-medium lg:!border-0 leading-30 lg:leading-80 py-2.5 px-5 lg:py-0 lg:px-[14px] text-textcolor hover:text-blue dark:!text-light dark:hover:text-white border-b  dark:border-[#4c5773]"
                            >
                                Blog
                            </Link>
                        </li>
                        <li>
                            <Link
                                onClick={() => setShow(false)}
                                href="/contact-us"
                                className="flex md:inline-block lg:hidden font-medium lg:!border-0 leading-30 lg:leading-80 py-2.5 px-5 lg:py-0 lg:px-[14px] text-textcolor hover:text-blue dark:text-light dark:hover:text-white border-b border-gray-100  dark:border-gray-700"
                            >
                                Contact Us
                            </Link>
                        </li>
                        <MenuBottomPanel className="block lg:hidden bg-grey" />
                    </Navbar.Collapse>
                </Navbar>
            </header>
        </>
    );
};
export default Header;
